import LinearCpms from "./LinearCpms";

export default LinearCpms;
